import React, { useEffect } from "react";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input } from "antd";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

interface BannerProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  bannerData?: { heading?: string; image?: string };
  loading?: boolean;
}

const Banner: React.FC<BannerProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  bannerData,
  loading,
}) => {
  useEffect(() => {
    if (bannerData) {
      form.setFieldsValue({
        banner: {
          heading: bannerData.heading || "",
          image: bannerData.image ? [bannerData.image] : [],
        },
      });
    } else {
      form.resetFields();
    }
  }, [bannerData, form]);


  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left text-sm md:text-base">
                    Banner
                  </th>
                  <th className="py-3 px-4 text-center text-sm md:text-base">
                    Heading
                  </th>
                  <th className="py-3 px-4 text-end text-sm md:text-base ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {bannerData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 w-[120px]">
                      <Image
                        src={bannerData?.image || "/placeholder.jpg"}
                        height={50}
                        width={120}
                        className="object-contain w-full h-full"
                        alt="Banner"
                      />
                    </td>
                    <td className="py-3 px-4 text-center text-gray-700">
                      {bannerData?.heading || "—"}
                    </td>
                    <td className="py-3 px-4 h-full text-primary">
                      <div className="flex items-center justify-end gap-4 h-full">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />

                        {/* <DeleteOutlined
                        className="cursor-pointer hover:text-red-600 text-[20px]"
                      /> */}
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="sm:hidden">
            {bannerData ? (
              <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Banner:
                  </span>
                  <Image
                    src={bannerData?.image || "/placeholder.jpg"}
                    height={70}
                    width={70}
                    className="object-contain w-full h-full"
                    alt="Banner"
                  />
                </div>

                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Heading:
                  </span>
                  <p>{bannerData?.heading || "—"}</p>
                </div>

                <div className="">
                  <span className="font-semibold text-primary block mb-1">
                    Action:
                  </span>
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-black text-[18px]"
                  />
                  {/* <DeleteOutlined
                  className="cursor-pointer hover:text-red-600 text-[18px]"
                /> */}
                </div>
              </div>
            ) : (
              <div className="bg-[#F9F9F9] border flex justify-center border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  {" "}
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        /* ----- Edit Mode ----- */
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["banner", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Banner Image"
                name={["banner", "image"]}
                rules={[
                  { required: true, message: "Please upload a banner image" },
                ]}
              >
                <UploadFoodImage maxUploadCount={1} bannerAspect={3 / 1} />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
